import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderTypeGroup } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useTemplate = () => {
  const { locale } = useLocale();
  const { mutate: downloadTemplate, isPending } = useAppMutation(
    [QueryKey.STAKEHOLDERS_DOWNLOAD_TEMPLATE],
    {
      mutationFn: ({
        companyId,
        typeGroup,
      }: {
        companyId: string;
        typeGroup: StakeholderTypeGroup;
      }) =>
        ApiService.downloadFile(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'stakeholders', typeGroup, 'template'],
          },
          { locale },
        ),
    },
  );
  return { downloadTemplate, isPending };
};
